/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlCategoryClass = {
    Endpoint: 'ENDPOINT',
    Identity: 'IDENTITY',
    Cloud: 'CLOUD',
    Email: 'EMAIL',
    Network: 'NETWORK',
    Data: 'DATA',
    Posture: 'POSTURE',
    Other: 'OTHER'
} as const;
export type ControlCategoryClass = typeof ControlCategoryClass[keyof typeof ControlCategoryClass];


export function ControlCategoryClassFromJSON(json: any): ControlCategoryClass {
    return ControlCategoryClassFromJSONTyped(json, false);
}

export function ControlCategoryClassFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCategoryClass {
    return json as ControlCategoryClass;
}

export function ControlCategoryClassToJSON(value?: ControlCategoryClass | null): any {
    return value as any;
}

